import React from 'react'

/**
 * Renders a red validation error message below a form field.
 * Works with react-hook-form `errors` objects or a plain string message.
 *
 * Usage (react-hook-form):
 *   <FieldError errors={errors} name="email" />
 *
 * Usage (plain message):
 *   <FieldError message="Name is required" />
 */

interface FieldErrorProps {
	/** react-hook-form errors object */
	errors?: Record<string, any>
	/** Field name key inside errors */
	name?: string
	/** Plain error string (overrides errors lookup) */
	message?: string
}

const FieldError: React.FC<FieldErrorProps> = ({ errors, name, message }) => {
	let msg = message
	if (!msg && errors && name && errors[name]) {
		msg = errors[name]['message'] || 'This field is required'
	}
	if (!msg) return null
	return (
		<p className="field-error-msg" role="alert">
			{msg}
		</p>
	)
}

export default FieldError

/** Red asterisk for required field labels */
export const RequiredMark = () => (
	<span className="ms-0.5 text-red-500 select-none" aria-hidden>
		*
	</span>
)
